import { createElement } from "react";
import { ButtonGroup, FlexMixin } from "@zillow/constellation";
import { negativeMarginMixin, CustomPropTypes } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import styled from "styled-components";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const StyleButtonGroup = /* @__PURE__ */ styled(ButtonGroup).withConfig({
  displayName: "ButtonGroup__StyleButtonGroup",
  componentId: "sc-koeb2i-0"
})(["", " ", ""], FlexMixin, negativeMarginMixin);
const BlockButtonGroup = ({
  attrs: {
    margin,
    justifyContent = {
      default: "flex-start"
    },
    alignItems = {
      default: "flex-start"
    },
    fluid = {
      default: false
    },
    direction = {
      default: "row"
    },
    ...attrs
  },
  index,
  innerBlocks
}) => /* @__PURE__ */ createElement(StyleButtonGroup, { justifyContent, alignItems, fluid, direction, ...attrs, ...margin, key: index }, generateBlockList({
  blocks: innerBlocks
}));
BlockButtonGroup.propTypes = {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})),
  attrs: PropTypes.shape({
    direction: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    fluid: CustomPropTypes.inlineMediaQuery(PropTypes.bool),
    conjoined: PropTypes.bool,
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    })),
    alignItems: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["stretch", "center", "flex-start", "flex-end", "baseline"])),
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "initial", "inherit"]))
  })
};
export {
  BlockButtonGroup as default
};
